import PropTypes from 'prop-types';
import React from 'react';
import IconButton from '../../icon-button';

const Menu = ({ glyph = 'floating-menu', ...props }) => (
  <div className="ws-ui-editor-header__menu">
    <IconButton {...props} glyph={glyph} />
  </div>
);

Menu.propTypes = {
  glyph: PropTypes.string,
};

export default Menu;
